export class Person {
    constructor(
        public id: string,
        public name: string,
        public organisations: string,
        public departments: string,
        public functions: string,
        public buildingName: string,
        public phoneNumbers: string[],
        public emailAddresses: string[],
        public rooms: string
    ){}
}